import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { downloadFile } from "../api/download";
import { isCanceled } from "../api/client";

export default function useDownload() {
  const controllerRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => () => {
    controllerRef.current?.abort();
    controllerRef.current = null;
  }, []);

  const download = useCallback(async (url, filename) => {
    if (controllerRef.current) return;
    const controller = new AbortController();
    controllerRef.current = controller;
    setLoading(true);
    try {
      await downloadFile(url, { filename, signal: controller.signal });
    } catch (error) {
      if (!controller.signal.aborted && !isCanceled(error) && error.status !== 401) {
        toast.error(error.message, {
          position: "bottom-left", rtl: true, autoClose: 4000,
        });
      }
    } finally {
      if (controllerRef.current === controller) {
        controllerRef.current = null;
        setLoading(false);
      }
    }
  }, []);

  return { download, loading };
}
